export default __webpack_public_path__ + "static/media/Mosaic3-min.7f2deec7.png";